import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          active: _ctx.soBank,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.soBank) = $event)),
          "active-readonly": "",
          hidePrevious: true,
          onUpdateProfile: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateProfile()))
        }), null, 16, ["active"])
      ]))
    : _createCommentVNode("", true)
}